/** 全局配置
 *
*/
module.exports = {
  /** 是否开启配置缓存 */
  OpenDevStorage: process.env.VUE_APP_ENV !== 'production'
}
